import * as React from 'react'
import Layout from 'src/components/layout'
import { graphql } from 'gatsby'
import Hero from 'src/components/sections/hero'
import TeaserWithHighlight from 'src/components/sections/teaser/TeaserWithHighlight'
import OurAwards from 'src/components/sections/our-awards'
import TrustedBy from 'src/components/sections/trusted-by'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import ContactSection from 'src/components/sections/ContactSection'

import { getPageContent } from 'src/helpers/pageContent'

const IndexPage = ({ data, pageContext }: any) => {
  const language = pageContext?.language || 'en'
  const translation = data?.directus?.pages?.[0]?.translations?.[0]
  const cmsJson = getPageContent('/services', language, translation?.content)

  if (!cmsJson || Object.keys(cmsJson).length === 0) {
    return <h1>Missing translation</h1>
  }

  const { t } = useTranslation('side-menu')

  return (
    <Layout title={cmsJson.title} metas={cmsJson.metas}>
      <Hero translationContent={cmsJson.weAreBigThinkersSection} />
      <div data-name={t('divisions')} id={t('divisions')}>
        <TeaserWithHighlight
          translationContent={cmsJson.imaginationSection}
          hideImage
          listLayout="interactive-rows"
          interactiveRowsVariant="compact"
        />
        <TeaserWithHighlight
          translationContent={cmsJson.designAndDevelopmentSection}
          hideImage
          listLayout="interactive-rows"
          interactiveRowsVariant="compact"
        />
        <TeaserWithHighlight
          translationContent={cmsJson.growthAndSupportSection}
          hideImage
          listLayout="interactive-rows"
          interactiveRowsVariant="compact"
        />
      </div>
      <TeaserWithHighlight
        translationContent={cmsJson.sportSection}
        splitRatio='7/12'
        imageMarginTop='md:mt-64'
        ctaVariant='link'
      />
      <TeaserWithHighlight
        translationContent={cmsJson.securitySection}
        splitRatio='7/12'
        imageMarginTop='md:mt-64'
      />
      <TeaserWithHighlight
        translationContent={cmsJson.technologySection}
        splitRatio='7/12'
        imageMarginTop='md:mt-64'
        ctaVariant='link'
      />
      <TeaserWithHighlight
        translationContent={cmsJson.processSection}
        hideImage
        listLayout="interactive-rows"
      />
      <OurAwards translationContent={cmsJson.awardsSection} />
      <TrustedBy translationContent={cmsJson.trustedBySection} />
      <ContactSection />
    </Layout>
  )
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    directus {
      pages(filter: { slug: { _eq: "/services" } }) {
        translations(filter: { languages_code: { code: { _eq: $language } } }) {
          content
        }
      }
    }
  }
`

export default IndexPage
